.card {
  background: transparent;
}

/* Header: title left, filter chips right (OG badger row) */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
  flex-wrap: wrap;
}

.title {
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  color: var(--text-primary);
  margin: 0;
}

.chips {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-left: auto;
}

.scopeSelect {
  min-width: 0;
}

/* Boxed body (OG .box: bordered, subtle gradient) */
.box {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: linear-gradient(to bottom, var(--bg-surface), var(--bg-card));
  overflow: hidden;
}

.summary {
  margin: var(--space-5) var(--space-5) var(--space-4);
  background: transparent;
  padding-left: 0;
  padding-right: 0;
  max-width: 110ch;
}

/* Breakdown / Metric — ruled toolbar between the sentence and the chart */
.filterRow {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-4);
  padding: var(--space-2) var(--space-5);
  border-top: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
  flex-wrap: wrap;
}

.toolbarDivider {
  width: 1px;
  height: 16px;
  background: var(--border-default);
}

.toggleGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.filterLabel {
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-caps);
  color: var(--text-muted);
}

/* Visualization grid: chart | rank table (OG 7fr / 370px) */
.visualization {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 370px;
  gap: var(--space-5);
  padding: var(--space-4) 0 var(--space-5) var(--space-5);
}

@media (max-width: 1200px) {
  .visualization {
    grid-template-columns: 1fr;
  }
}

.chartCol {
  min-width: 0;
}

.chartArea {
  min-width: 0;
}

/* Y title in its own column beside the plot (d360 YAxisLabels), so it can't
   collide with tick labels however wide they get. */
.plot {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
}

.yAxisTitle {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  margin-right: var(--space-2);
  white-space: nowrap;
  font-size: var(--text-sm);
  font-weight: var(--weight-bold);
  color: var(--text-secondary);
}

/* Bar value labels — Bebas, as d360 */
.totalLabel {
  font-family: var(--font-display);
  font-size: 15px;
  letter-spacing: 0.02em;
  fill: var(--text-primary);
}

.segmentLabel {
  font-family: var(--font-display);
  font-size: 13px;
  letter-spacing: 0.02em;
  fill: var(--text-on-accent, #fff);
  pointer-events: none;
}

/* Two-line quarter ticks */
.quarterTick {
  font-size: 11px;
  fill: var(--text-muted);
}

.quarterTickYear {
  fill: var(--text-disabled);
}

.hintIcon {
  color: var(--text-disabled);
  cursor: help;
  align-self: center;
}

.hintIcon:hover {
  color: var(--text-secondary);
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 360px;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

